import { render, staticRenderFns } from "./companyAttendance.vue?vue&type=template&id=e58520f0&"
import script from "./companyAttendance.vue?vue&type=script&lang=js&"
export * from "./companyAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports